//
// Comment Form
// Aspirations

// 1 . Box is by default collapsed

// 2 . When clicking anywhere on the box the input should be opened and focused

// 3 . Clicking any of the footer buttons do not collapse the form

// 4. Pressing cancel clears the input and collapses the box. Clearing any size modifications too
// ---------------------------------------------------------------------------

'use strict';

import Autolinker from 'autolinker';

const config = {
    singleComment: '.c-comment-card__body',
    rootNode: '.c-comment-form',
    textbox: '.c-comment-form__input',
    reset: '.c-comment-form__cancel',
    footer: '.c-comment-form__footer',
    inactiveClass: 'is-collapsed',
    escapeKeyCode: 27
};

let $container = $(config.rootNode),
    $textbox = $(config.textbox),
    $reset = $(config.reset),
    $attachment = $('.js-file-upload'),
    $label = $attachment.next('label').children('.js-attachment-label'),
    labelText = $label.html();

/**
 * On load add inactiveClass to containing element
 */
$container.addClass(config.inactiveClass);

/**
 * Wherever we click on inside the container, we want to enter into user input
 */
$container.on('click touch', function () {
    $textbox.focus();
});

/**
 * When we are focused on the form, we want to show the additional elements
 */
$textbox.on('focus', function () {
    $(this).closest(config.rootNode).removeClass(config.inactiveClass);
});

/**
 * When cancelling clear the fields and reset the form
 */
$reset.on('click', function () {
    $textbox.val('').removeAttr('style')
        .closest(config.rootNode).addClass(config.inactiveClass);

    $attachment.val('').trigger('change');
    return false;
});

/**
 * Ensure the label reads whatever the selected file is
 */
$attachment.on('change', function(e) {
    let fileName = '';

    if(this.files && this.files.length > 1) {
        fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
    } else if(e.target.value) {
        fileName = e.target.value.split('\\').pop();
    }

    if (fileName) {
        $label.text(fileName);
    } else {
        $label.text(labelText);
    }
});

$(document).ready(function () {
    const autolinker = new Autolinker({
        urls: {
            schemeMatches: true,
            wwwMatches: true,
            tldMatches: true
        },
        email: false,
        phone: false,
        mention: false,
        hashtag: false,

        stripPrefix: true,
        stripTrailingSlash : true,
        newWindow: true,

        truncate: {
            length: 0,
            location: 'end'
        }
    });

    $(config.singleComment).each(function () {
        const inHTML = $(this).html();
        const outHTML = autolinker.link(inHTML);
        $(this).html(outHTML);
    })
});



// WEBPACK FOOTER //
// ./src/js/components/comment-form.js